import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDuration',
    standalone: false
})
export class FormatDurationPipe implements PipeTransform {

  transform(duration: string | number | undefined, durationUTM?: string): string | undefined {
    if (!duration || isNaN(+duration)) return undefined;
    return duration + this.getPluralDuration(duration, durationUTM ?? 'Day');
  }

  protected getPluralDuration(duration: string | number, durationUnit: string) {
    if (!durationUnit) return '';
    const lastCharacter = durationUnit.charAt(durationUnit.length - 1);
    const castedDuration = typeof duration === 'string'? parseInt(duration) : duration;
    if (castedDuration == 1 || lastCharacter.toLowerCase() === 's') return ` ${durationUnit}`;
    const isLastCharacterLowercase = lastCharacter === lastCharacter.toLowerCase();
    return ` ${durationUnit}${isLastCharacterLowercase ? 's' : 'S'}`;
  }
}
